import { render } from "./Outbox.vue?vue&type=template&id=58ac662c&scoped=true"
import script from "./Outbox.vue?vue&type=script&lang=js"
export * from "./Outbox.vue?vue&type=script&lang=js"

import "./Outbox.vue?vue&type=style&index=0&id=58ac662c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/pins/pinsv2/Pins_Queuing_System/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ac662c"]])

export default __exports__